var _defs, _path, _path2, _g, _path3, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShopOnline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.936,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FFFFFF"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient5272",
    x1: 3.501,
    x2: 16.08,
    y1: 4.662,
    y2: 4.662,
    gradientTransform: "matrix(.85185 0 0 1.2909 -22.986 -17.53)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("style", null, ".a{fill:#372933}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1120",
    x1: 1.137,
    x2: 18.137,
    y1: 9.516,
    y2: 9.516,
    gradientTransform: "matrix(.8572 0 0 .85596 6.478 -.502)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1216",
    x1: -14.855,
    x2: -0.403,
    y1: 15.528,
    y2: 15.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1218",
    x1: 3.501,
    x2: 16.08,
    y1: 4.662,
    y2: 4.662,
    gradientTransform: "matrix(1.1489 0 0 1.2634 -3.602 -19.36)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1220",
    x1: 3.501,
    x2: 16.08,
    y1: 4.662,
    y2: 4.662,
    gradientTransform: "matrix(.85185 0 0 1.2909 6.38 -2.372)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.13 14.896c-3.204-.24-5.897-2.632-6.572-5.84-.139-.662-.14-2.162-.003-2.814.397-1.88 1.53-3.584 3.081-4.634 1.216-.823 2.597-1.24 4.101-1.24 3.508 0 6.41 2.374 7.18 5.874.144.649.144 2.146 0 2.796-.399 1.814-1.397 3.396-2.781 4.408-.607.443-.943.64-1.503.883a7.385 7.385 0 0 1-3.503.567z",
    fill: "none",
    stroke: "url(#linearGradient1120)",
    strokeWidth: 0.428
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.527 7.529h14.468v.428H7.527z",
    fill: "#FFFFFF",
    strokeWidth: 0.63874
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.079 2.606a5.358 2.079 0 0 1-2.68 1.8 5.358 2.079 0 0 1-5.357 0 5.358 2.079 0 0 1-2.679-1.8",
    stroke: "url(#linearGradient1220)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1)",
    d: "m-9.288-12.551a5.358 2.079 0 0 1-2.68 1.8 5.358 2.079 0 0 1-5.357 0 5.358 2.079 0 0 1-2.679-1.8",
    stroke: "url(#linearGradient5272)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90)",
    d: "M14.872-14.487a7.226 2.034 0 0 1-3.613 1.762 7.226 2.034 0 0 1-7.226 0A7.226 2.034 0 0 1 .42-14.487",
    stroke: "url(#linearGradient1218)",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-90)",
    d: "M-.403 14.51a7.226 2.034 0 0 1-3.613 1.763 7.226 2.034 0 0 1-7.226 0 7.226 2.034 0 0 1-3.613-1.762",
    stroke: "url(#linearGradient1216)",
    strokeWidth: 0.5
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.169 10.144h8.585v7.515H5.169z",
    fill: "#483D8B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.937 10.676h11.364v.5H1.937z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-2.826)",
    d: "M1.981 13.219h10.577v.5H1.981z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-5.53)",
    d: "M1.859 15.802h10v.5h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.998 -.06336 .04643 .99892 0 0)",
    d: "M3.018 17.118h9.163v.5H3.018z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.01675 -.99986 1 -.00325 0 0)",
    d: "M-15.128 12.622h4.408v.5h-4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.2974 -.95475 .77305 -.63435 0 0)",
    d: "M-17.143-1.64h8.751v.558h-8.751z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.99019 -.13973 .02435 -.9997 0 0)",
    d: "M-1.883-8.937h1.646v.499h-1.646z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.24785 -.9688 .97205 -.23475 0 0)",
    d: "M-16.322 1.74h4.408v.5h-4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.24785 -.9688 .97205 -.23475 0 0)",
    d: "M-16.868 4.239h4.408v.5h-4.408z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(-.24785 -.9688 .97205 -.23475 0 0)",
    d: "M-17.322 6.611h4.408v.5h-4.408z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.288,
    cy: 18.66,
    r: 1.134
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.824,
    cy: 18.368,
    r: 1.134
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopOnline);
export default __webpack_public_path__ + "static/media/shop_online.9e43f15a6bce18a80f2addaefac1ae20.svg";
export { ForwardRef as ReactComponent };